import React from 'react';
import { Row, Col, Tooltip, Button } from 'antd';
import { useAtomValue, useSetAtom } from 'jotai';
import { aiCohortDrawerAtom, selectedProductAtom } from '../atoms';
import { PRODUCT_MODE_MAP } from '@src/utils/constants';
import { SEVERITY_CONFIG } from '@src/components/ai-alerts/ContentPanel/utils';
import { SubscriptionCategoryName } from './styled';
import { getMetricMetaByKey } from '@src/utils/metrics';
import { ApartmentOutlined } from '@ant-design/icons';
import { ScanIconWrap } from '../../styled';
import { BetaTag } from '../styled';

const SEVERITY_LABEL_STYLE: React.CSSProperties = { fontWeight: 500, fontSize: 14 };

export function EiSeverityHeaders() {
  return (
    <>
      <Col span={5}>
        <div style={{ ...SEVERITY_LABEL_STYLE, color: SEVERITY_CONFIG.Info.color }}>Info</div>
      </Col>
      <Col span={5}>
        <div style={{ ...SEVERITY_LABEL_STYLE, color: SEVERITY_CONFIG.Warning.color }}>Warning</div>
      </Col>
      <Col span={4}>
        <div style={{ ...SEVERITY_LABEL_STYLE, color: SEVERITY_CONFIG.Critical.color }}>
          Critical
        </div>
      </Col>
    </>
  );
}

export function AiCohortsButton({
  metrics,
  headerKey,
  isFlow = false,
  disabled = false,
}: {
  metrics: string[];
  headerKey: string;
  isFlow?: boolean;
  disabled?: boolean;
}) {
  const setOpenAICohortDrawer = useSetAtom(aiCohortDrawerAtom);

  return (
    <Tooltip title={disabled ? 'Please save sensitivity to access AI Cohorts' : 'Go to AI Cohorts'}>
      <Button
        onClick={(e) => {
          e.stopPropagation();
          setOpenAICohortDrawer({
            open: true,
            metrics,
            key: getMetricMetaByKey({ metricKey: metrics[0] })?.flowID || headerKey,
            isFlow,
          });
        }}
        disabled={disabled}
        type="primary"
        ghost
        style={{ border: 'none', padding: '0 10px' }}
      >
        <ScanIconWrap>
          <ApartmentOutlined />
        </ScanIconWrap>
      </Button>
    </Tooltip>
  );
}

const PanelHeader = ({
  metric,
  metrics,
  showAICohortButton,
  disableAICohortButton,
  isFlow,
  showBeta = false,
}) => {
  const selectedProduct = useAtomValue(selectedProductAtom);

  return (
    <Row gutter={{ xs: 8, sm: 16, md: 24, lg: 32 }} style={{ width: '100%' }}>
      {selectedProduct === PRODUCT_MODE_MAP.AI ? (
        <>
          <Col span={13}>
            <SubscriptionCategoryName>{metric}</SubscriptionCategoryName>
          </Col>
          <Col span={11}>
            <div style={{ ...SEVERITY_LABEL_STYLE, color: SEVERITY_CONFIG.Info.color }}>Info</div>
          </Col>
        </>
      ) : (
        <>
          <Col span={10}>
            <div style={{ display: 'flex', alignItems: 'center' }}>
              {showAICohortButton ? (
                <AiCohortsButton
                  metrics={metrics}
                  headerKey={metric}
                  isFlow={isFlow}
                  disabled={disableAICohortButton}
                />
              ) : null}
              <SubscriptionCategoryName>
                {metric}
                {showBeta ? <BetaTag>Beta</BetaTag> : null}
              </SubscriptionCategoryName>
            </div>
          </Col>
          <EiSeverityHeaders />
        </>
      )}
    </Row>
  );
};

export default PanelHeader;
